import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { AppShell } from "@/components/layout/AppShell";
import { monterFamis } from "@/famis/famisStudio";
import "@/famis/famis.css";

/**
 * Outils › Script FAMIS : générateur de scripts BlueZone (.bbs) pour la
 * time card FAMIS FS-110 (utilisateur seul ou multi-utilisateur).
 * L'outil d'origine (page HTML autonome) est monté tel quel dans la page.
 */
export default function FamisPage() {
  const conteneur = useRef(null);
  useEffect(() => monterFamis(conteneur.current, (m) => toast(m)), []);
  return (
    <AppShell title="Script FAMIS">
      <div ref={conteneur} className="famis" data-testid="famis" />
    </AppShell>
  );
}
